import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';
import FormField from 'screens/Companies/components/FormField';

const CityField = () => {
  return (
    <FormField label="City" htmlFor="city">
      <FormikInput id="city" name="address.city" />
    </FormField>
  );
};

export default CityField;
